import { Button } from "@mui/material";
import { StyledActions } from "../../styled/formik";

const FormikActions = ({
  handleCancel,
  submitText,
  cancelText,
  thirdButtonText,
  disabled,
  hasThirdButton,
  handleThirdButton,
}) => {
  return (
    <StyledActions.Container>
      <StyledActions.Button
        onClick={handleCancel}
        color="primary"
        type="button">
        {cancelText ? cancelText : "Cancelar"}
      </StyledActions.Button>
      <Button
        color="primary"
        type="submit"
        variant="contained"
        disabled={disabled}>
        {submitText ? submitText : "Aceptar"}
      </Button>
      {hasThirdButton && (
        <StyledActions.ThirdButton
          color="primary"
          variant="contained"
          type="submit"
          disabled={disabled}
          onClick={handleThirdButton}>
          {thirdButtonText}
        </StyledActions.ThirdButton>
      )}
    </StyledActions.Container>
  );
};

export default FormikActions;
